require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./photos-professional-zam-x-2-u.json") })
        }
      }, "path---photos-professional-zam-x-2-u");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---photos-professional-zam-x-2-u!./.cache/json/photos-professional-zam-x-2-u.json
// module id = 1175
// module chunks = 231608221292675